export const API_URL = "/api/";
export const PDFTronLicense = "iBabs BV(ibabs.eu):OEM:iBabs Portal::B+:AMS(20210327):1F641D5DF6457E2BC82F7495DE8BA7448DCB84DBB744744BC26420F9A632513DF5C7";
//export const API_URL = "https://localhost:44372/";